import * as complaintPositionsTypes from '../types/ComplaintPositions';
import * as complaintPositionValidatorActions from './Validators/ComplaintPositionValidator';
import * as errorActions from './Error';
import * as pageActions from './Page';

export  function SaveComplaintPostion(complaintPosition) {
    return async (dispatch, getState) => {
        try {
            dispatch(errorActions.clearError());
            const complaintType = getState().complaint.complaintType;
            const customer = getState().customer;
            validateComplaintPosition(complaintPosition, complaintType);
            await complaintPositionValidatorActions.validateThatSalesDocumentExists(complaintPosition, complaintType, customer);
        } catch (error) {
            return dispatch(errorActions.throwNewError("Błąd walidacji", error.message));
        }
        try {
            if(complaintPosition.id && complaintPosition.id > 0) {
                dispatch(EditComplaintPosition(complaintPosition));
            }
            else {
                const id = getState().complaintPositions.positions.length + 1;
                if (getState().util.allowMultiplePositionsForComplaint == true) {
                    dispatch(AddComplaintPosition(complaintPosition, id));
                }
                else{
                    dispatch(AddSingleComplaintPosition(complaintPosition, id));
                }
            }

            //sterowanie stroną
            if (getState().util.allowMultiplePositionsForComplaint == true) {
                dispatch(pageActions.changePageToCreateComplaintPositions());
            }
            else{
                dispatch(pageActions.changePageToCrateComplaintPreview());
            }
        } catch (error) {
            return dispatch(errorActions.throwNewError("Błąd zapisu danych", error.message));
        }
    };
}

export function AddComplaintPosition(complaintPosition, id) {
    return (dispatch) => {
        complaintPosition.id=id;
        complaintPosition.productDisplayName=complaintPosition.product.name;
        complaintPosition.quantityCorrectionsProposalDisplayName =complaintPosition.quantityCorrectionsProposal.displayNext;
        dispatch(AddPostition(complaintPosition));
    };
}

export function AddSingleComplaintPosition(complaintPosition, id) {
    return (dispatch) => {
        complaintPosition.id=id;
        complaintPosition.productDisplayName=complaintPosition.product.name;
        complaintPosition.quantityCorrectionsProposalDisplayName =complaintPosition.quantityCorrectionsProposal.displayNext;
        dispatch(AddSinglePostition(complaintPosition));
    };
}

function AddSinglePostition(complaintPosition) {
    return {
        type: complaintPositionsTypes.COMPLAINT_POSITIONS_ADD_SINGLE_COMPLAINT_POSITION,
        payload: complaintPosition
    };
}

function validateComplaintPosition(complaintPosition, complaintType) {
    switch (complaintType.name) {
        case "Warranty":
            complaintPositionValidatorActions.validateWarrantyPosition(complaintPosition);
            break;
        case "SalesWarranty":
            complaintPositionValidatorActions.validateSalesWarrantyPosition(complaintPosition);
            break;
        case "DeliveryMismatch": 
            complaintPositionValidatorActions.validateDeliveryMismatchPosition(complaintPosition);
            break;
        case "PayedRepair":
            complaintPositionValidatorActions.validatePayedRepairPosition(complaintPosition);
            break;
        case "UnderWarrantyLaserDeviceCalibration":
            complaintPositionValidatorActions.validateUnderWarrantyLaserDeviceCalibrationPosition(complaintPosition);
            break;
        case "TransportDamage":
            complaintPositionValidatorActions.validateTransportDamagePosition(complaintPosition);
            break;
        case "PostWarrantyLaserDeviceCalibration": 
            complaintPositionValidatorActions.validatePostWarrantyLaserDeviceCalibrationPosition(complaintPosition);
            break;
    } 
}

export function EditComplaintPosition(complaintPosition){
    return {
        type: complaintPositionsTypes.EDIT_COMPLAINT_POSITION,
        payload: complaintPosition
    };
}

export function DeleteComplaintPosition(complaintPosition){
    return {
        type: complaintPositionsTypes.DELETE_COMPLAINT_POSITION,
        complaintPosition: complaintPosition
    };
}

function AddPostition(complaintPosition) {
    return {
        type: complaintPositionsTypes.COMPLAINT_POSITIONS_ADD_COMPLAINT_POSITION,
        payload: complaintPosition
    };
}


// WEBPACK FOOTER //
// ./src/actions/ComplaintPositions.js